import { Grid, Row, Col, MainContainer } from '@sketchpixy/rubix';
import { IndexRoute, Route } from 'react-router';
import React from 'react';

import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';
import { Roles } from 'roles';

import AccountPage from '../components/users/Account.page';
import AlertAddPage from '../components/alerts/AlertAdd.page';
import AlertEditPage from '../components/alerts/AlertEdit.page';
import AlertListPage from '../components/alerts/AlertList.page';
import CalendarPage from '../components/reservations/Calendar.page';
import CalendarPageV2 from '../components/reservations/CalendarV2.page';

import FlightsTypeFormPage from '../components/flights-type/FlightsTypeForm.page';
import FlightsTypeListPage from '../components/flights-type/FlightsTypeList.page';
import Footer from '../components/layout/footer';
import Header from '../components/layout/header';
import HomePage from '../components/home/page-home';
import LoginPage from '../components/auth/LoginPage';
import MontgolfiereAddPage from
'../components/montgolfieres/MontgolfiereAdd.page';
import MontgolfiereEditPage from
'../components/montgolfieres/MontgolfiereEdit.page';
import MontgolfiereViewPage from
'../components/montgolfieres/MontgolfiereView.page';
import MontgolfiereListPage from
'../components/montgolfieres/MontgolfiereList.page';
import MyFlightsPage from '../components/statistiques/MyFlights.page';
import FlightDetailPage from '../components/flights/FlightDetail.page';

import OptionsFormPage from '../components/options/OptionsForm.page';
import OptionsListPage from '../components/options/OptionsList.page';
import PlaceAddPage from '../components/places/PlaceAdd.page';
import PlaceEditPage from '../components/places/PlaceEdit.page';
import PlaceListPage from '../components/places/PlaceList.page';
import PlanificationAddMultiplePage from
'../components/planifications/PlanificationAddMultiplePage';
import PlanificationListPage from
'../components/planifications/PlanificationListPage';
import PlanningPage from '../components/flights/PlanningPage';
import PlanningProgrammePage from '../components/flights/PlanningProgrammePage';
import PricesFormPage from '../components/prices/PricesForm.page';
import PricesListPage from '../components/prices/PricesList.page';
import PromotionsFormPage from '../components/promotions/PromotionsForm.page';
import PromotionsListPage from '../components/promotions/PromotionsList.page';
import ReservationsAddPage from '../components/reservations/page-reservations-add';
import ReservationsPage from '../components/reservations/page-reservations-list';
import ReservationsViewPage from '../components/reservations/page-reservations-view';
import Sidebar from '../components/layout/sidebar';
import UserAddPage from '../components/users/UserAdd.page';
import UserEditPage from '../components/users/UserEdit.page';
import UserListPage from '../components/users/UserList.page';
import StatistiquesPage from '../components/statistiques/Statistiques.page';
import PartnerListPage from '../components/partners/PartnerList.page';
import PartnerEditPage from '../components/partners/PartnerEdit.page';
import GroupBillListPage from '../components/partners/GroupBillList.page';
import GroupBillAddPage from '../components/partners/GroupBillAdd.page';
import GroupBillViewPage from '../components/partners/GroupBillView.page';

import ExportsPage from '../components/exports/Exports.page';
import SMSPage from '../components/sms/Sms.page';

import ContactPage from '../components/layout/contact';
import NotFoundPage from '../components/layout/404';


class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		if(_.includes(Meteor.user().roles, 'partner'))
			this.state.partner = true;
		else
			this.state.partner = false;
	}

	componentWillMount() {
		Tracker.autorun((computation) => {
			if (Meteor.loggingIn() || !Roles.isReady())
				return ;

			this.forceUpdate();
			computation.stop();
		})
	}

	render() {
		return (
			<MainContainer {...this.props}>
				<Sidebar />
				<Header />
				<div id='body'>
					<Grid>
						<Row>
							<Col xs={12}>
								{this.props.children}
							</Col>
						</Row>
					</Grid>
				</div>
				<Footer />
			</MainContainer>
		);
	}
}

function requireAuth(nextState, replace, callback) {
	Tracker.autorun((computation) => {

		if (Meteor.loggingIn())
			return ;

		if (!Meteor.user()) {
			return replace({
				pathname: '/login',
				state: { nextPathname: nextState.location.pathname }
			});
		}

		computation.stop();
		callback();
	});
}

function allowToEnter(nextState, replace, callback) {

	if(_.includes(Meteor.user().roles, 'partner')) {
		replace({
			pathname: '/error',
			state: { nextPathname: nextState.location.pathname }
		});
	}

	callback();
}

export default function () {
	return (
		<div>
			<Route path='/'>
				<IndexRoute component={LoginPage} />
				<Route path='/login'					component={LoginPage} />
			</Route>

			<Route path='/app' component={App} onEnter={requireAuth}>
				<IndexRoute component={HomePage} />

				<Route path='/account'							 component={AccountPage} />
				<Route path='/calendrier'						 component={CalendarPageV2} />
				<Route path='/calendrier2'						 component={CalendarPageV2} />
				<Route path='/contact'                           component={ContactPage} />

				<Route path='/reservations'	                     component={ReservationsPage} />
				<Route path='/reservations-add'		             component={ReservationsAddPage} />
				<Route path='/reservations/:id'		             component={ReservationsViewPage} />

				<Route path='/planning'				             component={PlanningPage} onEnter={allowToEnter} />
				<Route path='/planning/flights/:flightId'		 component={PlanningProgrammePage} onEnter={allowToEnter}/>

				<Route path='/users'				             component={UserListPage} onEnter={allowToEnter}/>
				<Route path='/users/add'			             component={UserAddPage} onEnter={allowToEnter}/>
				<Route path='/users/:id'			             component={UserEditPage} onEnter={allowToEnter}/>

				<Route path='/my-flights'						 component={MyFlightsPage} onEnter={allowToEnter}/>
				<Route path='/flights/:id/detail'			     component={FlightDetailPage} onEnter={allowToEnter}/>

				<Route path='/partners'						     component={PartnerListPage} onEnter={allowToEnter}/>
				<Route path='/partners/:id'						 component={PartnerEditPage} onEnter={allowToEnter}/>
				<Route path='/group-bills'				         component={GroupBillListPage} onEnter={allowToEnter}/>
				<Route path='/group-bills/add'				         component={GroupBillAddPage} onEnter={allowToEnter}/>

				<Route path='/promotions'			             component={PromotionsListPage} onEnter={allowToEnter}/>
				<Route path='/promotions-add'		             component={PromotionsFormPage} onEnter={allowToEnter}/>
				<Route path='/promotions/:id'		             component={PromotionsFormPage} onEnter={allowToEnter}/>

				<Route path='/options'				             component={OptionsListPage} onEnter={allowToEnter}/>
				<Route path='/options-add'			             component={OptionsFormPage} onEnter={allowToEnter}/>
				<Route path='/options/:id'			             component={OptionsFormPage} onEnter={allowToEnter}/>

				<Route path='/flights'				             component={FlightsTypeListPage} onEnter={allowToEnter}/>
				<Route path='/flights-add'			             component={FlightsTypeFormPage} onEnter={allowToEnter}/>
				<Route path='/flights/:id'			             component={FlightsTypeFormPage} onEnter={allowToEnter}/>

				<Route path='/prices'				             component={PricesListPage} onEnter={allowToEnter}/>
				<Route path='/prices/:id'			             component={PricesFormPage} onEnter={allowToEnter}/>
				<Route path='/prices-add'			             component={PricesFormPage} onEnter={allowToEnter}/>

				<Route path='/montgolfieres'		             component={MontgolfiereListPage} onEnter={allowToEnter}/>
				<Route path='/montgolfieres/add'	             component={MontgolfiereAddPage} onEnter={allowToEnter}/>
				<Route path='/montgolfieres/:id'	             component={MontgolfiereEditPage} onEnter={allowToEnter}/>
				<Route path='/montgolfieres/:id/view'            component={MontgolfiereViewPage} onEnter={allowToEnter}/>

				<Route path='/places'		             		 component={PlaceListPage} onEnter={allowToEnter}/>
				<Route path='/places/add'	             		 component={PlaceAddPage} onEnter={allowToEnter}/>
				<Route path='/places/:id'	             		 component={PlaceEditPage} onEnter={allowToEnter}/>

				<Route path='/alerts'		             		 component={AlertListPage} onEnter={allowToEnter}/>
				<Route path='/alerts/add'	             		 component={AlertAddPage} onEnter={allowToEnter}/>
				<Route path='/alerts/:id'	             		 component={AlertEditPage} onEnter={allowToEnter}/>

				<Route path='/planifications'					 component={PlanificationAddMultiplePage} onEnter={allowToEnter}/>
				<Route path='/exports'					       component={ExportsPage} onEnter={allowToEnter}/>
				<Route path='/sms'					       component={SMSPage} onEnter={allowToEnter}/>

				<Route path='/statistiques'                      component={StatistiquesPage} onEnter={allowToEnter}/>

				<Route path='/error'                               component={NotFoundPage} />

			</Route>
		</div>
	);
}



/** WEBPACK FOOTER **
 ** ./src/universal/routes/index.js
 **/